import sound from 'assets/sound/water-drop.mp3'

export const toastConfig = {
  timeout: 5000,
  sound
}
